const includes = (array, value) => array.indexOf(value) !== -1;
export { includes as default };
